export default __webpack_public_path__ + "static/media/project-image-placeholder.f0b862dc.png";